import { createStore } from 'react-use-sub';

const [useChatStore, ChatStore] = createStore({
  chatId: '',
  secondaryMenuContent: undefined,
  status: 'open'
});


export { useChatStore, ChatStore };